module.exports = __webpack_public_path__ + "static/skitrip5-4ae9f6618dad9e3bc072bc2340985a2f.png";